import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

// actions
import { doneIndicator, error } from '../../actions/standardActions';

// api
import doctorAPI from '../../sources/api/doctorAPI';

// constants
import { DOCTOR_AVAILABILITIES_FETCH_FOR_OFFICE } from '../../constants/doctorTypes';

// lib
import httpSaga from '../../lib/httpSaga';

// schemas
import { doctorAvailabilityListSchema } from '../../schemas/Normalizr';

export function* doctorAvailabilitiesFetchForOffice(action) {
  if (action['@@redux-saga/SAGA_ACTION']) return;

  const params = action.payload;

  try {
    yield *httpSaga(DOCTOR_AVAILABILITIES_FETCH_FOR_OFFICE, call(doctorAPI.availabilitiesFetchForOffice, params), doctorAvailabilityListSchema);
  } catch (e) {
    yield put(error(DOCTOR_AVAILABILITIES_FETCH_FOR_OFFICE, e));
  } finally {
    yield put(doneIndicator(DOCTOR_AVAILABILITIES_FETCH_FOR_OFFICE));
  }
}

export function* watchDoctorAvailabilitiesFetchForOffice() {
  yield takeEvery(DOCTOR_AVAILABILITIES_FETCH_FOR_OFFICE, doctorAvailabilitiesFetchForOffice);
}

export default function* root() {
  yield all([
    fork(watchDoctorAvailabilitiesFetchForOffice)
  ]);
}



// WEBPACK FOOTER //
// ./app/sagas/doctor/doctorAvailabilitiesFetchForOffice.js